/**
 * This interface is for an request plugin.
 * @type {string}
 */
const name = 'requests'
export default name
